import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { ArrowLeft, Briefcase, Award, TrendingUp } from 'lucide-react';
export function CareerJourneys() {
  return <div className="bg-zen-bg min-h-screen text-zen-text" data-id="element-126">
      <Navbar data-id="element-127" />
      <main className="pt-32 pb-20 px-6" data-id="element-128">
        <div className="max-w-4xl mx-auto" data-id="element-129">
          <a href="/" className="inline-flex items-center gap-2 text-zen-text/60 hover:text-zen-accent mb-8 transition-colors" data-id="element-130">
            <ArrowLeft className="w-4 h-4" data-id="element-131" /> Back to Home
          </a>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-6xl font-moon-dance mb-6" data-id="element-132">
            Career Journeys
          </motion.h1>

          <p className="text-xl text-zen-text/70 mb-16 leading-relaxed" data-id="element-133">
            A timeline of professional growth, technical challenges, and the
            lessons learned along the way.
          </p>

          <div className="space-y-12" data-id="element-134">
            {[{
            role: 'Technology Support III (Associate)',
            company: 'JP Morgan Chase & Co',
            period: 'Jan 2025 - Present',
            icon: TrendingUp,
            details: ['Managing nightly automation jobs to ensure stability and quick failure resolution.', 'Designing Groovy + Cucumber automation frameworks for web and mobile.', 'Leading end-to-end manual, regression, and mobile QA initiatives.']
          }, {
            role: 'Test Specialist',
            company: 'IBM India Pvt. Ltd',
            period: 'Jun 2022 - Jan 2025',
            icon: Award,
            details: ['Developed comprehensive test scenarios with business analysts.', 'Contributed to regression automation and Jenkins-managed test environments.', 'Participated in requirement reviews and sprint ceremonies.']
          }, {
            role: 'Software Products & Platform Engineering',
            company: 'Accenture Solutions',
            period: 'Dec 2017 - Jun 2022',
            icon: Briefcase,
            details: ['Translated user requirements into detailed functional/UI test cases.', 'Developed Java + Selenium automation scripts expanding coverage.', 'Built and optimized automated test suites for new features.']
          }].map((job, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-white p-8 rounded-3xl shadow-sm border border-zen-text/5" data-id="element-135">
                <div className="flex items-start justify-between mb-6 flex-wrap gap-4" data-id="element-136">
                  <div className="flex items-center gap-4" data-id="element-137">
                    <div className="p-3 bg-zen-accent/10 rounded-xl text-zen-accent" data-id="element-138">
                      <job.icon className="w-6 h-6" data-id="element-139" />
                    </div>
                    <div data-id="element-140">
                      <h3 className="text-2xl font-bold text-zen-text" data-id="element-141">
                        {job.role}
                      </h3>
                      <p className="text-zen-accent font-medium" data-id="element-142">
                        {job.company}
                      </p>
                    </div>
                  </div>
                  <span className="px-4 py-1 bg-zen-text/5 rounded-full text-sm font-medium text-zen-text/60" data-id="element-143">
                    {job.period}
                  </span>
                </div>

                <ul className="space-y-3 pl-4 border-l-2 border-zen-accent/20 ml-3" data-id="element-144">
                  {job.details.map((detail, i) => <li key={i} className="text-zen-text/70 pl-4 relative" data-id="element-145">
                      <span className="absolute -left-[21px] top-2 w-2 h-2 rounded-full bg-zen-accent" data-id="element-146"></span>
                      {detail}
                    </li>)}
                </ul>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-147" />
    </div>;
}